'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    /**
     * 自分の投稿した Idea 一覧を取得する
     *
     * @param limit {number}
     * @param cursor {string}
     * @returns {*}
     */
    getUserIdeas(limit, cursor) {
        const path = `/api/feedback/my/ideas`;
        let params = new URLSearchParams();

        params.append('limit', limit);

        if(cursor) {
            params.append('nextCursor', cursor);
        }

        return Ajax.GET(`${path}?${params.toString()}`);
    }

    /**
     * 公開されている Idea 一覧を取得する
     *
     * @param limit {number}
     * @param cursor {string}
     * @returns {*}
     */
    getPublicIdeas(limit, cursor) {
        const path = `/api/feedback/ideas`;
        let params = new URLSearchParams();

        params.append('limit', limit);

        if(cursor) {
            params.append('nextCursor', cursor);
        }

        return Ajax.GET(`${path}?${params.toString()}`);
    }

    getIdeaByID(ideaID) {
        const path = `/api/feedback/ideas/${ideaID}`;

        return Ajax.GET(path);
    }

    create(json) {
        return Ajax.POST(`/api/feedback/ideas`, json);
    }

    fetchComments(ideaID) {
        return Ajax.GET(`/api/feedback/ideas/${ideaID}/comments`);
    }

    comment(ideaID, json) {
        return Ajax.POST(`/api/feedback/ideas/${ideaID}/comments`, json);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./feedback/infra/api/idea.js